import { render, staticRenderFns } from "./SkribbleFrameworkAgreement.vue?vue&type=template&id=afb56310&scoped=true&"
import script from "./SkribbleFrameworkAgreement.vue?vue&type=script&lang=js&"
export * from "./SkribbleFrameworkAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb56310",
  null
  
)

export default component.exports